import { Controller } from '@hotwired/stimulus'
import { enter, leave } from 'el-transition'

// Connects to data-controller="modal"
export default class extends Controller {
  static targets = ['modalArea']

  connect() {
    document.body.addEventListener('click', (e) => {
      if (!this.modalAreaTarget.contains(e.target)) {
        leave(this.element)
      }
    })
  }

  close(event) {
    event?.preventDefault()
    leave(this.element)
  }
}
